import { Link } from 'react-router-dom';
import { LOGO, salon } from '../../data/content';

/** Het logo als link naar de homepage. De linknaam komt van de salonnaam uit de instellingen. */
export function Logo({
  className = 'h-11'
}: {
  className?: string;
}) {
  return <Link to="/" aria-label={`${salon.name} — naar de homepage`} className="inline-flex shrink-0 items-center transition-opacity duration-150 ease-soft hover:opacity-75" data-id="element-7851" data-mp="1rhymi8lxlqoc">
      {/* De link heeft al een naam; het beeld hoeft niet nog eens voorgelezen te worden. */}
      <img src={LOGO} alt="" className={`${className} w-auto mix-blend-multiply`} data-id="element-7852" data-mp="1dqtunsot22ok" />
    </Link>;
}